import React, { useCallback, useEffect, useState } from "react";
import { getSavedJobs, getSavedJobsbyJSId, removeSavedJob } from "../../api/savedjobsApi"; // make sure this exists
import { applyNow } from "../../api/applyNowApi";       // optional, for Apply Now

const boxStyle = {
  width: "48px",
  height: "48px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: "bold",
};

function SavedJobs() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [savedJobIds, setSavedJobIds] = useState([]);
  const appUserId = localStorage.getItem("aUId");
  const token = localStorage.getItem("otoken");


//   useEffect(() => {
//   const loadSavedJobs = async () => {
//     try {
//       setLoading(true);
//       setError("");

//       const data = await getSavedJobsbyJSId(appUserId, token); // returns { jobs: [...] }
//       const savedIds = await getSavedJobs(appUserId, token);   // returns array savedJobIds or []

//       // debug logs
//       console.log("Jobs:", data.jobs);
//       console.log("Saved IDs (array):", savedIds);

//       // set state
//       setJobs(data.jobs || []);
//       setSavedJobIds(savedIds || []); // savedIds is already the array
//     } catch (err) {
//       console.error("Failed to load saved jobs:", err);
//       setError("Failed to load saved jobs");
//     } finally {
//       setLoading(false);
//     }
//   };

//   loadSavedJobs();
// }, [appUserId, token]);

const loadSavedJobs = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const data = await getSavedJobsbyJSId(appUserId, token); // returns { jobs: [...] }
      const savedIds = await getSavedJobs(appUserId, token);   // returns array

      console.log("Jobs:", data.jobs);
      console.log("Saved IDs (array):", savedIds);

      setJobs(data.jobs || []);
      setSavedJobIds(savedIds || []);
    } catch (err) {
      console.error("Failed to load saved jobs:", err);
      setError("Failed to load saved jobs");
    } finally {
      setLoading(false);
    }
  }, [appUserId, token]); // depends on these

  // call on mount / when appUserId or token changes
  useEffect(() => {
    if (!appUserId || !token) return;
    loadSavedJobs();
  }, [appUserId, token, loadSavedJobs]);


  const handleApply = async (job_id) => {
    try {
      const res = await applyNow(job_id, appUserId, token);
      alert("Application submitted successfully!");
      console.log(res);
    } catch (err) {
      console.error("Apply failed:", err);
      alert(err.response?.data?.error || "Failed to apply");
    }
  };

  // optional, once you create a remove API:
  // const handleRemove = async (job_id) => {
  //   // TODO: call removeSavedJob API then:
  //   setJobs((prev) => prev.filter((j) => j.job_id !== job_id));
  // };

  const handleRemove = async (job_id) => {
  try {
    // optimistic UI update
    setJobs(prev => prev.filter(j => j.job_id !== job_id));
    setSavedJobIds(prev => prev.filter(id => id !== job_id));

    const res = await removeSavedJob(appUserId, job_id, token);

    if (!res.success) {
      // revert UI if delete failed
      // (optional: re-fetch list instead of full revert)
      console.error("Could not remove saved job on server");
      // re-fetch or revert: simple approach below:
      await loadSavedJobs(); // re-run your fetch function to sync with server
    }
  } catch (err) {
    console.error("Remove error:", err);
    await loadSavedJobs(); // ensure UI sync
  }
};


  const getInitials = (title = "") => {
    const parts = title.trim().split(" ");
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  };

  return (
    <div className="container mt-5">
      <h3 className="mb-4 text-center">My Saved Jobs</h3>

      {loading && <p className="text-center">Loading...</p>}
      {error && <p className="text-center text-danger">{error}</p>}
      {!loading && !error && jobs.length === 0 && (
        <p className="text-center">You have no saved jobs yet.</p>
      )}

      <div className="row">
        <div className="col-md-8 mx-auto">
          {jobs.map((job) => (
            <div className="card mb-3" key={job.id}>
              <div className="card-body d-flex flex-column flex-md-row align-items-center justify-content-between">
                <div className="d-flex flex-column flex-md-row align-items-center">
                  <div className="bg-primary text-white rounded-circle mr-3" style={boxStyle} title={job.company_name}>
                    {getInitials(job.company_name)}
                  </div>
                  <div>
                    <h5 className="card-title mb-1">{job.title}</h5>
                    <p className="mb-0">
                      <i className="zmdi zmdi-pin mr-2"></i> {job.job_location}
                    </p>
                    <p className="mb-0">
                      <i className="zmdi zmdi-money mr-2"></i>
                      ₹{job.min_salary} - ₹{job.max_salary} / yearly
                    </p>
                    <p className="mb-0">
                      <i className="zmdi zmdi-time mr-2"></i>
                      {job.work_mode || "Full Time"}
                    </p>
                  </div>
                </div>

                <div className="mt-3 mt-md-0">
                  <button
                    className="btn btn-outline-primary mr-2"
                    onClick={() => handleApply(job.job_id)}
                    disabled={savedJobIds.includes(job.job_id)}
                  >
                    {savedJobIds.includes(job.job_id) ? "Applied" : "Apply Now"}
                  </button>
                  <button
                    className="btn btn-outline-danger"
                    onClick={() => handleRemove(job.job_id)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SavedJobs;
